import {
  TrendingUp,
  TrendingDown,
  PlusSquare,
  MinusSquare,
} from "lucide-react";

class ActionType {
  constructor(value, title, icon, iconColor) {
    this.value = value;
    this.title = title ?? value;
    this.icon = icon;
    this.iconColor = iconColor;
  }
}

const actionsTypes = [
  new ActionType("sell", "Продажа", TrendingUp, "#009966"),
  new ActionType("purchase", "Покупка", TrendingDown, "#155dfc"),
  new ActionType("investment", "Ввод средств", PlusSquare, "#4f39f6"),
  new ActionType("conclusion", "Вывод средств", MinusSquare, "#e17100"),
];

export default actionsTypes;
